import { render, staticRenderFns } from "./IndustrialPanel.vue?vue&type=template&id=0a9c14f0&scoped=true&"
import script from "./IndustrialPanel.vue?vue&type=script&lang=js&"
export * from "./IndustrialPanel.vue?vue&type=script&lang=js&"
import style0 from "./IndustrialPanel.vue?vue&type=style&index=0&id=0a9c14f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c14f0",
  null
  
)

export default component.exports